import { paths } from "src/paths";

const STORAGE_KEY = "last_page";

const collectPathValues = (value: unknown, acc: string[] = []): string[] => {
  if (typeof value === "string") {
    if (value.startsWith("/") && !value.startsWith("//")) {
      acc.push(value);
    }
    return acc;
  }

  if (value && typeof value === "object") {
    Object.values(value).forEach((nested) => collectPathValues(nested, acc));
  }

  return acc;
};

const knownPaths = collectPathValues(paths);

const excludedPaths = new Set([
  paths.auth.firebase.login,
  paths.auth.firebase.register,
  paths.auth.firebase.forgotPassword,
  paths.dashboard.wait,
  paths.dashboard.paymentSuccessful,
  paths.dashboard.paymentFailed,
]);

const pathnameOf = (pathWithSearch: string): string =>
  pathWithSearch.split("?")[0] || "";

const matchesKnownPath = (pathname: string): boolean =>
  knownPaths.some((known) => {
    if (known === pathname) {
      return true;
    }

    if (known.includes(":")) {
      const pattern = `^${known.replace(/:[^/]+/g, "[^/]+")}$`;
      return new RegExp(pattern).test(pathname);
    }

    return false;
  });

const isRememberablePath = (pathname: string): boolean => {
  if (!pathname.startsWith("/") || pathname.startsWith("//")) {
    return false;
  }

  if (!pathname.includes("/dashboard")) {
    return false;
  }

  if (pathname.startsWith("/auth") || excludedPaths.has(pathname)) {
    return false;
  }

  return matchesKnownPath(pathname);
};

export const rememberLastPage = (path: string): void => {
  const pathname = pathnameOf(path);

  if (!isRememberablePath(pathname)) {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, path);
  } catch (err) {
    console.error(err);
  }
};

export const resolveLastPage = (fallback: string): string => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);

    if (!stored) {
      return fallback;
    }

    const pathname = pathnameOf(stored);

    if (!isRememberablePath(pathname)) {
      return fallback;
    }

    return stored;
  } catch (err) {
    console.error(err);
    return fallback;
  }
};
